"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxFetchMeetingTimeSuggestionsArgs = void 0;
var HxTimeSpan_1 = require("./HxTimeSpan");
var HxTimeRange_1 = require("./HxTimeRange");
var HxLocationConstraints_1 = require("./HxLocationConstraints");
var HxAttendeeConstraints_1 = require("./HxAttendeeConstraints");
function serializeHxFetchMeetingTimeSuggestionsArgs(_arg) {
    var output = [];
    output.push(_arg.requestId);
    output.push(_arg.isLocationRequired);
    output.push(_arg.suggestLocation);
    output.push(_arg.isOrganizerOptional);
    output.push(_arg.suggestionsRange);
    output.push(HxTimeSpan_1.serializeHxTimeSpan(_arg.meetingDuration));
    output.push(_arg.maxNumberOfSuggestions);
    var timeSlotsCollectionOutput = [];
    _arg.timeSlotsCollection.forEach(function (item) { return timeSlotsCollectionOutput.push(HxTimeRange_1.serializeHxTimeRange(item)); });
    output.push(timeSlotsCollectionOutput);
    var locationConstraintsCollectionOutput = [];
    _arg.locationConstraintsCollection.forEach(function (item) { return locationConstraintsCollectionOutput.push(HxLocationConstraints_1.serializeHxLocationConstraints(item)); });
    output.push(locationConstraintsCollectionOutput);
    var attendeeConstraintsCollectionOutput = [];
    _arg.attendeeConstraintsCollection.forEach(function (item) { return attendeeConstraintsCollectionOutput.push(HxAttendeeConstraints_1.serializeHxAttendeeConstraints(item)); });
    output.push(attendeeConstraintsCollectionOutput);
    output.push(_arg.manualSyncModeBehavior);
    return output;
}
exports.serializeHxFetchMeetingTimeSuggestionsArgs = serializeHxFetchMeetingTimeSuggestionsArgs;
